import { render, staticRenderFns } from "./CoozzyAlert.vue?vue&type=template&id=a3f0bbcc&scoped=true"
import script from "./CoozzyAlert.vue?vue&type=script&lang=js"
export * from "./CoozzyAlert.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAlert.vue?vue&type=style&index=0&id=a3f0bbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f0bbcc",
  null
  
)

export default component.exports